import { Box, Divider, Link, Typography } from "@mui/material";
import { InfoWindow } from "@vis.gl/react-google-maps";
import DataLabel from "components/DataLabel";
import { Company } from "models/Company";
import type { RouteInfo } from "../util/formatRouteInfo";
import { useCompaniesContext } from "../CompaniesContext";

type CompanyInfoProps = {
  company: Company;
  routeInfo: RouteInfo | null;
  onClose: () => void;
};

const CompanyInfo: React.FC<CompanyInfoProps> = (props) => {
  const { company, routeInfo, onClose } = props;

  const { setSelectedCompanyId } = useCompaniesContext();

  return (
    <InfoWindow
      position={{ lat: company.latitude, lng: company.longitude }}
      onCloseClick={onClose}
      headerContent={
        <Link
          component="button"
          underline="none"
          fontWeight="bold"
          fontSize="inherit"
          onClick={() => setSelectedCompanyId(company.id)}
        >
          {company.name}
        </Link>
      }
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {company.region && <DataLabel label="Arbetsområde">{company.region}</DataLabel>}

        <DataLabel label="Timpris">
          {company.hourlyRate ? (
            <>
              <Typography component="span" fontWeight="bold" fontSize="1.1em" color="primary.dark">
                {company.hourlyRate}
              </Typography>{" "}
              kr/h{" "}
            </>
          ) : (
            "-"
          )}
        </DataLabel>
      </Box>
      {routeInfo && (
        <>
          <Divider sx={{ my: 2, backgroundColor: "text.secondary" }} />

          <Box display="flex" justifyContent="space-between" gap={2}>
            <DataLabel label="Avstånd">
              <>
                <Typography
                  component="span"
                  fontWeight="bold"
                  fontSize="1.1em"
                  color="primary.dark"
                >
                  {routeInfo.kilometers}
                </Typography>{" "}
                km{" "}
              </>
            </DataLabel>

            <DataLabel label="Restid">
              {routeInfo.duration.hours ? (
                <>
                  <Typography
                    component="span"
                    fontWeight="bold"
                    fontSize="1.1em"
                    color="primary.dark"
                  >
                    {routeInfo.duration.hours}
                  </Typography>{" "}
                  h{" "}
                </>
              ) : null}
              <>
                <Typography
                  component="span"
                  fontWeight="bold"
                  fontSize="1.1em"
                  color="primary.dark"
                >
                  {routeInfo.duration.minutes}
                </Typography>{" "}
                min
              </>
            </DataLabel>
          </Box>
        </>
      )}
    </InfoWindow>
  );
};

export default CompanyInfo;
